package com.xtream.composeapp.viewmodel.livetv

import androidx.lifecycle.viewModelScope
import androidx.paging.cachedIn
import com.xtream.composeapp.viewmodel.SearchViewModelImpl
import com.xtream.composeapp.viewmodel.SearchViewModelInterface
import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.db.repo.LiveStreamsRepository
import com.xtream.data_kmp.db.repo.WatchedLiveRepository
import com.xtream.data_kmp.db.tables.LiveStreamOrderEntity
import com.xtream.data_kmp.dto.LiveCategory
import com.xtream.data_kmp.dto.LiveStream
import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.FlowPreview
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.debounce
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext

class StreamControlViewModel (
    private val liveStreamsRepository: LiveStreamsRepository,
    watchedLiveRepository: WatchedLiveRepository
): LiveStreamsViewModel(liveStreamsRepository, watchedLiveRepository), SearchViewModelInterface by SearchViewModelImpl() {


    var selectedPosition = MutableStateFlow(0)
   /* TODO implement expect/actual val mediaFormat = MutableStateFlow<Format?>(null)
    val mediaVideoSize = mediaFormat.transform {

        if (it != null && it.width != NO_VALUE && it.height != NO_VALUE)
            emit("${it.width} x ${it.height}")
        else
            emit("")
    }.stateIn(
        viewModelScope,
        started = SharingStarted.WhileSubscribed(),
        initialValue = ""
    )*/


    var selectedPositionTemp = MutableStateFlow("")
    var tvChannelsLength = MutableStateFlow<Int?>(null) // or 0
    var selectedVodPosition = MutableStateFlow(0)

    val selectedPlus: StateFlow<Int> = selectedPosition.map { pos ->
        pos + 1
    }.stateIn(
        scope = viewModelScope,
        started = SharingStarted.WhileSubscribed(5000),
        initialValue = 0
    )

    var selectedChannel = MutableStateFlow<LiveStream?>(null)
    var selectedTvGroup = MutableStateFlow<LiveCategory?>(null)
    var playingCategory = MutableStateFlow<LiveCategory?>(null)
    val getTvChannelsWithSortOrder = selectedTvGroup
        .flatMapLatest { group ->
            tvStreamsRepo.getOrdered(group?.categoryId)
        }
        .stateIn(
            scope = viewModelScope,
            started = SharingStarted.WhileSubscribed(5000),
            initialValue = emptyList()
        )



    val tvCategoriesWithVisibleStatus = tvStreamsRepo
        .getCategoriesWithVisibleStatus()
        .stateIn(
            scope = viewModelScope,
            started = SharingStarted.WhileSubscribed(5000),
            initialValue = emptyList()
        )
    fun toggleCategoryVisibility(category: LiveCategory){
        viewModelScope.launch {
            tvStreamsRepo.toggleLiveCategory(category)
        }
    }

    val liveStreamsFilteredPagingFlow =
        combine(
            searchFlow,
             selectedCategoriesFlow
        ) { keyWord, categories ->
            val categoryIds = categories?.map { it.categoryId }
            keyWord to categoryIds
        }
            .distinctUntilChanged()
            .flatMapLatest { (keyWord, categories) ->
                getPagedLiveStreamsFlow(categoryIds = categories?.filterNotNull(), keyWord)
            }
            .cachedIn(viewModelScope)

    fun emitSelectedTvChannel(channel: LiveStream?) {
        selectedChannel.tryEmit(channel)
    }

    fun emitSelectedTvChannel(
        position: Int?,
        channel: LiveStream?,
        currentCategory: LiveCategory? = selectedTvGroup.value
    ) {

        viewModelScope.launch(Dispatchers.Default) {
            selectedChannel.value = channel
            selectedPosition.value = position ?: -1
            emitPlayingCategory(currentCategory ?: getCategory( channel?.categoryId ?: -1))


        }
    }


    fun getChannel() = selectedChannel.value?.streamId
    fun getCurrentPosition() = selectedPosition.value
    suspend fun addSelectedPositionTemp(value: String?) {
        val limitIndex = withContext(Dispatchers.Default) { selectedCategorySize().toString().length }
        /*if (SharedBuildKonfig.DEBUG) {
            println("${limitIndex == selectedPositionTemp.value?.length} $limitIndex == ${selectedPositionTemp.value?.length}")
        }*/
        if (value.isNullOrEmpty() ||
            limitIndex == selectedPositionTemp.value?.length ||
            (value == "0" && selectedPositionTemp.value == "")
        ) return

        selectedPositionTemp.value += value
    }

    fun resetSelectedPositionTemp() {
        selectedPositionTemp.value = ""
    }

    fun emitGroup(tvChannelsGroupsModel: LiveCategory?) {
        viewModelScope.launch {

            selectedTvGroup.emit(tvChannelsGroupsModel)
           // Log.d("SelectedTVVmodel", "emitGroup: ${selectedTvGroup.value}")
        }

    }

    fun emitPlayingCategory(tvChannelsGroupsModel: LiveCategory?) {

        playingCategory.tryEmit(tvChannelsGroupsModel)
        emitGroup(tvChannelsGroupsModel)

    }

    fun updateSelectedBy(addBy: Int, offset: Int = -1) {

        val position =  //if offset not available then send current position
            if (offset == -1)
                selectedPosition.value
            else offset


        viewModelScope.launch {
            liveStreamsRepository.findNextItem(
                position, addBy,
                playingCategory.value?.categoryId
            )
            { item, pos ->
                emitSelectedTvChannel(pos, item, playingCategory.value)
            }
        }

    }


    suspend fun selectedCategorySize() =
        liveStreamsRepository.streamsSize(selectedTvGroup.value?.categoryId)

    suspend fun playingCategorySize() = with(liveStreamsRepository) {
        if (playingCategory.value?.categoryId == AllConst.FAV_CATEGORIES_ID.toInt())
            favStreamsSize()
        else if (playingCategory.value?.categoryId == AllConst.ALL_CATEGORIES_ID.toInt())
            streamsSize()
        else
            streamsSize(playingCategory.value?.categoryId)
    }

    /**
     * checks weather the given stream is available in Favorites Table?
     * @property  stream stream item to be checked
     * @return Flow< Boolean> returns true if the stream is in favorites table otherwise false
     **/
    val isFavoriteFlow =
        combine(
            selectedChannel,
            liveStreamsRepository.isFavoriteAsFlow(selectedChannel.value?.streamId ?: -1)
        ) { s, f ->

            return@combine if (s == null) false else liveStreamsRepository.isFavorite(s.streamId)

        }.stateIn(
            scope = viewModelScope,
            started = SharingStarted.WhileSubscribed(),
            initialValue = false
        )


    @OptIn(ExperimentalCoroutinesApi::class, FlowPreview::class)
    val liveStreamsFlow: StateFlow<List<LiveStream>?> = selectedTvGroup.flatMapLatest { category ->
        when (category?.categoryId) {
            AllConst.FAV_CATEGORIES_ID.toInt() -> tvStreamsRepo.getFavoritesAsFlow()
            AllConst.ALL_CATEGORIES_ID.toInt() -> tvStreamsRepo.getStreamsAsFlow(null, null)
            else -> tvStreamsRepo.getStreamsAsFlow(category?.categoryId, null)
        }
    }.debounce(300).stateIn(
        CoroutineScope(Dispatchers.Default), // Use appropriate coroutine scope
        SharingStarted.Lazily,
        null // Initial value
    )
    val lastPlayedStream: StateFlow<Int?> = liveStreamsFlow.map { streams ->
        streams?.indexOfFirst { it.streamId == selectedChannel.value?.streamId }
    }.stateIn(
        scope = viewModelScope,
        started = SharingStarted.WhileSubscribed(),
        initialValue = null
    )

    val isSelectedCategoryPlaying get() = playingCategory.value?.categoryId == selectedTvGroup.value?.categoryId


    /**
     * finds index of the given stream in the db, if not found returns -1
     */
    suspend fun indexOf(streamId: Int, categoryId: Int? = null): Int {
        return liveStreamsRepository.indexOf( streamId=streamId, categoryId=categoryId) ?: -1
    }

    suspend fun findStreamByIndex(index: Int,categoryId: Int?):LiveStream? {
       val item=  liveStreamsRepository.findItemByOffset(
            index,
             categoryId,
        )
         return item
    }
     fun insertToSortOrder(order: LiveStreamOrderEntity)= viewModelScope.launch{ tvStreamsRepo.insertToSortOrder(order) }
     fun resetToSortOrderFrom(category: LiveCategory?)= viewModelScope.launch{ tvStreamsRepo.resetToSortOrderFrom(category) }
    // In StreamControlViewModel (or repository)
    suspend fun findSortedByIndex(index: Int, categoryId: Int) =
        tvStreamsRepo.findSortedByIndex(index, categoryId)

    suspend fun findAllStreamsSorted(categoryId: Int) =
        tvStreamsRepo.findAllSorted(categoryId)

    fun shiftPositionsBetween(
        categoryId: Int?,
        lowerBound: Double?, // 👈 Changed to Double?
        upperBound: Double?, // 👈 Changed to Double?
        delta: Double,
        onDone: (() -> Unit)? = null
    ) = viewModelScope.launch(Dispatchers.Default) {
        // Execute the update query safely
        tvStreamsRepo.shiftPositionsBetween(categoryId, lowerBound, upperBound, delta)

        // Switch to Main thread if your onDone callback updates Compose state or UI
        withContext(Dispatchers.Main) {
            onDone?.invoke()
        }
    }



    fun swap(from: Int, to: Int, dispatcher: CoroutineDispatcher){

        viewModelScope.launch(dispatcher) {
            val original = getTvChannelsWithSortOrder.value.getOrNull(from)
            val otherItem = getTvChannelsWithSortOrder.value.getOrNull(to)

            val draggedItemNewPos = otherItem?.order?.position ?: otherItem?.liveStream?.num
            //dragged item

         with(tvStreamsRepo) {

             if (original?.liveStream?.streamId != null && draggedItemNewPos != null) {
                 insertToSortOrder(
                     LiveStreamOrderEntity(
                         streamId = original.liveStream.streamId,
                         categoryId = original.liveStream.categoryId,
                         position = draggedItemNewPos.toDouble()
                     )
                 )
             }

             val otherItemNewPos = original?.order?.position ?: original?.liveStream?.num
             //other item
             if (otherItem?.liveStream?.streamId != null && otherItemNewPos != null) {
                 insertToSortOrder(
                     LiveStreamOrderEntity(
                         streamId = otherItem.liveStream.streamId,
                         categoryId = otherItem.liveStream.categoryId,
                         position = otherItemNewPos.toDouble()
                     )
                 )
             }
         }
        }
    }

}


